module.exports = __webpack_public_path__ + "media/icons/lock@2x-90b98510.png";